import { HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES, AxwayTokenFetcherService } from '@ptl/xhr';
import { CookieService } from 'ngx-cookie-service';
import { RedirectService } from '../../../shared/services/redirect.service';
import { environment } from 'src/environments/environment';
import { ENTITLEMENTS, EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure, USER_ROLE } from '@ptl/account-management';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';
import { API_ENDPOINTS } from '../../../../shared/constants/api-endpoints.constant';

@Component({
    selector: 'app-apm-sso',
    templateUrl: './apm-sso.component.html',
    styleUrls: ['./apm-sso.component.scss'],
    standalone: false
})
export class ApmSsoComponent implements OnInit {

  @Input() apmLabel: string;

  apmForm: UntypedFormGroup;
  loginData: UserInfoStateStructure;

  doesUserHaveAccess: boolean;
  lob: LINE_OF_BUSINESS_ENUM;

  constructor(
    private httpClient: HTTPWrapperContext,
    private cookieService: CookieService,
    private fb: UntypedFormBuilder,
    private redirectService: RedirectService,
    private entitlementService: EntitlementsHelperService,
    private reducerUtilityService: ReducerUtilityService,
    private authoringMode: AuthoringModeService,
    private axwayTokenFetcherService: AxwayTokenFetcherService
  ) { }

  async ngOnInit(): Promise<void> {
    this.apmForm = this.fb.group({
      destinationURL: this.fb.control('ICMBROKER')
    });

    this.loginData = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
    
    this.lob = await this.entitlementService.getCurrentLobPromise();
    this.loginData = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

    const selectedAgency = (
      this.loginData &&
      this.loginData.userInfo &&
      this.loginData.userInfo.agencyInfo &&
      this.loginData.userInfo.agencyInfo.selectedAgencies &&
      this.loginData.userInfo.agencyInfo.selectedAgencies[this.lob]
    );

    this.doesUserHaveAccess = (() => {

      if (this.authoringMode.getAuthoringMode()) { return true; }

      if (!this.authoringMode.getAuthoringMode()) {

        /**
         * INTERNAL role needs to worry about LOB and [0] agency,
         * other roles do not, because their agencies have entitlements
         */
        const selectedAgencyEntitlements = (() => {

          const isInternalUser = this.loginData.basicUserInfo.userType.toLocaleLowerCase() === USER_ROLE.INTERNAL.toLowerCase();

          if (isInternalUser) {
            switch (this.lob) {
              case LINE_OF_BUSINESS_ENUM.INDIVIDUAL: return (
                  this.loginData.userInfo.broker360ACAAgencies &&
                  this.loginData.userInfo.broker360ACAAgencies[0].entitlements
                );
              case LINE_OF_BUSINESS_ENUM.SENIOR: return (
                  this.loginData.userInfo.broker360Agencies &&
                  this.loginData.userInfo.broker360Agencies[0].entitlements
                );
              case LINE_OF_BUSINESS_ENUM.SMALL_GROUP: return (
                  this.loginData.userInfo.agencies &&
                  this.loginData.userInfo.agencies[0].entitlements
                );
            }
          } else {
            return selectedAgency.entitlements;
          }

        })();

        if (selectedAgencyEntitlements) {
          for (const entitlement of selectedAgencyEntitlements) {
            if (entitlement.descriptionKey === ENTITLEMENTS.AGENCY_REPORTS) {
              if (entitlement.hasEntitlement === true) {
                return true;
              }
            }
          }
        }

      }
    })();

  }

  async runSSO($event: Event) {
      // prevent default 'a' link behavior
      $event.preventDefault();

      const isInternal = this.loginData.basicUserInfo.userType.toLowerCase() === USER_ROLE.INTERNAL.toLowerCase();
      let prodUrl = '';
      let testUrl = '';

      const hmInternalProdAbbr = "hmarkprod1";
      const hmInternalTestAbbr = "hmarktest1";
      const ndInternalProdAbbr = "bcbsnd";
      const ndInternalTestAbbr = "bcbsndtest2";

      if (environment.initData.brand.ASPID === "ND") {
        prodUrl = "https://" + ndInternalProdAbbr + ".callidusinsurance.net/ICM/";
        testUrl = "https://" + ndInternalTestAbbr + ".callidusinsurance.net/ICM/";
      } else if (environment.initData.brand.ASPID === "HM") {
        prodUrl = "https://" + hmInternalProdAbbr + ".callidusinsurance.net/ICM/";
        testUrl = "https://" + hmInternalTestAbbr + ".callidusinsurance.net/ICM/";
      }

      if (isInternal) {
        if (window.location.hostname.indexOf('env') >= 0) {
          window.open(testUrl, "_blank");
        } else {
          window.open(prodUrl, "_blank");
        }
      } else {
        await this.makePreRequest();

        let target = "https://" + environment.external.vendors.agentCubeUrl;
        let postParams = { destinationURL: 'ICMBROKER', target }
        this.redirectService.post(postParams);
      }

  }

  private async makePreRequest(): Promise<any> {
    let selectedAgency = await this.entitlementService.getSelectedAgencyPromise();

    let preRequestUrl = this.axwayTokenFetcherService.buildApiUrl(API_ENDPOINTS.SECURE_APP.ICM, { partyId: selectedAgency.agencyPartyId });
    // let preRequestUrl = `/cmcrst/x-services/secure/icm/${selectedAgency.agencyPartyId}`;
    let preRequestPayload = {
      "baseMessage": {
        "headerVersion": "1.0",
        "payloadVersion": "2.0",
        "additionalInfo": null
      },
      "payload": {}
    };

    const ltpaToken = this.cookieService.get('LtpaToken2');
    const requestConfig = new RequestConfigImplementation({
      url: preRequestUrl,
      method: REQUEST_METHODS.POST,
      headers: new HttpHeaders({
        // 'Custom-HMHS': `LTPAtoken2= ${ltpaToken};Domain=.highmark.com;Path=/;`
 
      }),
      POST_OR_PUT_PAYLOAD: preRequestPayload
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS_V4);
    return this.httpClient.makeRequest(requestConfig);
  }
}
